
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { User } from '@/lib/models/User'
import { FileCheck } from '@/lib/utils/FileCheck'
import BacLazyImage from '@/components/BacLazyImage.vue'

import CryptoJS from 'crypto-js'

@Component({
  components: {
    BacLazyImage
  }
})
export default class BacCustomerWidget extends Vue {
    @Prop({ required: true }) private user!: User;
}

